import { Fragment, type FunctionComponent } from 'react';
import { type MessageDescriptor, defineMessages, useIntl } from 'dibs-react-intl';
import styles from './styles/SellerApplicationByTheNumbers.scss';

const values = {
    item1: 362,
    item2: 136000,
    item3: 6.3,
    item4: 850000,
    item5: 90000,
    item6: 2500,
};
const messages = defineMessages({
    heading: { id: 'DealerApplicationByTheNumbers.heading', defaultMessage: 'By the numbers' },
    body: {
        id: 'DealerApplicationByTheNumbers.body',
        defaultMessage:
            'Our rapidly growing {qty}+ person team is here to provide expertise in engineering, marketing and logistics to set you up for success on our platform.',
    },
});

const listMessagesStrong = defineMessages({
    item1: {
        id: 'DealerApplicationByTheNumbers.itemStrong1',
        defaultMessage: '${qty} million',
    },
    item2: {
        id: 'DealerApplicationByTheNumbers.itemStrong2',
        defaultMessage: '{qty}+',
    },
    item3: {
        id: 'DealerApplicationByTheNumbers.itemStrong3',
        defaultMessage: '{qty} million',
    },
    item4: {
        id: 'DealerApplicationByTheNumbers.itemStrong4',
        defaultMessage: '{qty}+',
    },
    item5: {
        id: 'DealerApplicationByTheNumbers.itemStrong5',
        defaultMessage: '{qty}+',
    },
    item6: {
        id: 'DealerApplicationByTheNumbers.itemStrong6',
        defaultMessage: '${qty}+',
    },
});
const listMessagesBody = defineMessages({
    item1: {
        id: 'DealerApplicationByTheNumbers.itemBody1',
        defaultMessage: ' sales last year',
    },
    item2: {
        id: 'DealerApplicationByTheNumbers.itemBody2',
        defaultMessage: 'orders in 2023',
    },
    item3: {
        id: 'DealerApplicationByTheNumbers.itemBody3',
        defaultMessage: 'registered users',
    },
    item4: {
        id: 'DealerApplicationByTheNumbers.itemBody4',
        defaultMessage: 'pieces listed at net price for trade',
    },
    item5: {
        id: 'DealerApplicationByTheNumbers.itemBody5',
        defaultMessage: 'members in our verified trade program',
    },
    item6: {
        id: 'DealerApplicationByTheNumbers.itemBody6',
        defaultMessage: 'average order value',
    },
});

type ListMessageKeys = keyof typeof listMessagesStrong & keyof typeof listMessagesStrong;

const Item: FunctionComponent<{
    strongMessage: MessageDescriptor;
    bodyMessage: MessageDescriptor;
    qty: number;
    itemKey: string;
}> = ({ strongMessage, bodyMessage, qty, itemKey }) => {
    const intl = useIntl();
    const strong = intl.formatMessage(strongMessage, { qty: intl.formatNumber(qty) });
    const body = intl.formatMessage(bodyMessage, { qty: intl.formatNumber(qty) });
    return (
        <li key={itemKey} className={styles.item}>
            <strong className={styles.itemStrong}>{strong}</strong>
            <span className={styles.itemBody}>{body}</span>
        </li>
    );
};

const ByTheNumbers: FunctionComponent = () => {
    const intl = useIntl();
    const heading = intl.formatMessage(messages.heading);
    const body = intl.formatMessage(messages.body, { qty: intl.formatNumber(300) });
    const messageKeys = Object.keys(listMessagesStrong) as ListMessageKeys[];
    return (
        <Fragment>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.body}>{body}</p>
            <ul className={styles.list}>
                {messageKeys.map(key => (
                    <Item
                        key={key}
                        itemKey={key}
                        strongMessage={listMessagesStrong[key]}
                        bodyMessage={listMessagesBody[key]}
                        qty={values[key]}
                    />
                ))}
            </ul>
        </Fragment>
    );
};
export const SellerApplicationByTheNumbers = ByTheNumbers;
